
export default {
    reportlist:[{
        'id':1,
        'url':'https://pic.motortime.com/avatar/2c/84/2c84c07b1bcbc3e44c823e23d2e756d5.jpg',
        'title':'电动汽车发展报告（上）',
        'content':'专家指出，在电动汽车领域，我国和西方发达国家处在同一起跑线上，某些方面还处于世界领先地位，这为我国汽车工业技术实现跨越发展提供了一次历史性的机遇。更重要的是我国还有后发优势。有关分析认为，电动汽车所以在西方没有发展起来，表面原因是成本没有降到可以与燃油汽车相竞争的水平，但更深层次的原因是传统汽车工业强大的惯性。',
        'start':'2023-06-01',
    },{
        'id':2,
        'url':'https://pic.motortime.com/avatar/df/46/df46366a613530037b5228edac809711.jpg',
        'title':'电动汽车发展报告（下）',
        'content':'事实上，能量传递的各个环节不可能都处在最高效率的状态。如果各个环节都按平均效率计算，靠电网提供能源的电动汽车的总效率约在12%～23%之间，远远低于内燃机。虽然电动汽车在行驶过程中的污染很低.',
        'start':'2023-05-22',
    },{
        'id':3,
        'url':'https://pic.motortime.com/avatar/a4/9a/a49a30371c7333e9900db243b8e1c615.jpg',
        'title':'汽车物流行业的现状及发展',
        'content':'据保守估计，中国未来汽车保有量将达到4.9亿辆左右，届时超过日本，成为全球第二。汽车产业的高速发展为中国汽车物流带来成倍的增长空间。',
        'start':'2023-04-18',
    },{
        'id':4,
        'url':'https://pic.motortime.com/avatar/f0/e6/f0e65c85e9be8e6876de5339935e8b81.jpg',
        'title':'汽车销售行业调研报告',
        'content':'在新车利润逐渐下降的形势影响下，二手车销售成为新车经销商的主要利润来源。一些豪华车制造商也在极力促进认证二手车的发展，为一些没有能力购买某些特定新车型的消费者提供服务。在美国经济整体下滑的趋势下，消费者对二手车的需求会随着新车销售的下降而上升。',
        'start':'2023-03-14',
    },{
        'id':5,
        'url':'https://pic.motortime.com/avatar/ce/ab/ceab08363c779869a0baf314210de6fa.jpg',
        'title':'汽车行业数字化营销分析报告',
        'content':'汽车市场从增量市场逐渐转化为存量市场，车企不再以经销商为销售中心，逐渐转向以消费者为中心的营销模式。当前的汽车营销正在通过各种技术打通数据壁垒，融通多元数据、实现用户全景洞察。',
        'start':'2022-12-11',
    },{
        'id':6,
        'url':'https://pic.motortime.com/avatar/ff/73/ff73ca5f5f4404f4baeeb008c096d68f.jpg',
        'title':'汽车音响系统创新研究',
        'content':'我国汽车音响技术的发展，应该是从1994年以后才开始有了初级阶段，从更换主机、更换简单的扬声器，直到安装功率放大器和低音的阶段，这时才有了音响系统。随着改革开放，国外著名品牌的进入，才使我国汽车音响改装产生了巨大的变化，尤其是改装技术方面通过交流培训得到了提高。',
        'start':'2022-11-08',
    },{
        'id':7,
        'url':'https://pic.motortime.com/avatar/91/0d/910ddf9174cdd42e92001966a029d143.jpg',
        'title':'燃油车行业发展报告（上）',
        'content':'国内涡轮增压器配置率将持续提升，尤其是汽油机涡轮增压器配置率提升空间巨大。面对与日俱增的环保和能源压力，内燃机节能减排是大势所趋。',
        'start':'2022-10-04',
    },{
        'id':8,
        'url':'https://pic.motortime.com/avatar/7f/f3/7ff3fb49999fa88531b1af3259d72b25.jpg',
        'title':'燃油车行业发展报告（下）',
        'content':'混合动力有望实现15%-50%的节油潜力。混合动力可划分为轻混合动力系统、辅助混合动力系统(中混)、深度混合动力系统，分别有望实现15%、30%、50%的节油潜力。如果采用插电式混合动力，则有望实现80%以上的节油潜力。',
        'start':'2022-09-29',
    },{
        'id':9,
        'url':'https://pic.motortime.com/avatar/6c/52/6c526030514c544b36dc9493d3a6c738.jpg',
        'title':'微型电动车市场需要报告',
        'content':'作为影响潜在消费者的主要购车因素剩下价格及使用成本，就需要车企在产品技术上不断升级，生产出性价比更高的车型，以匹配后续消费者涌现的新需求，同时也要求经销商与车企联合推出更多的优惠活动，更多让利于消费者。',
        'start':'2022-09-26',
    },{
        'id':10,
        'url':'https://pic.motortime.com/avatar/73/13/7313383a348454943eba029cd57adb1f.jpg',
        'title':'新能源汽车产业调研报告',
        'content':'随着全球气候变化的加剧以及对化石能源的依赖问题，新能源汽车作为一种环保、高效、可持续发展的交通方式，受到越来越多的关注和青睐。作为新兴产业，新能源汽车在未来的发展前景十分广阔。',
        'start':'2022-09-18',
    },{
        'id':11,
        'url':'https://pic.motortime.com/avatar/bf/28/bf28a0097bdfcf311c16633ca8d8c5ca.jpg',
        'title':'中国电动车发展现状',
        'content':'中国汽车产业发展到今天，经历了从技术引进、消化吸收到自主研发的过程。对于新兴的电动车产业，是应当遵循汽车产业的传统发展路径，还是应自主研发、独辟蹊径，至今仍未有定论。',
        'start':'2022-09-06',
    }]
}


// WEBPACK FOOTER //
// ./src/libs/report.js